/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_UploadInputs */



/**
* | output |
* | --- |
* | "Upload template" |
*
* @param {Presentation_Template_Master_UploadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_upload = /** @type {((inputs?: Presentation_Template_Master_UploadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_UploadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlage hochladen")
	return /** @type {LocalizedString} */ ("Upload template")
});